<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Les Types de Gouvernance</h1>
      <div>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de bord</a></router-link></li>
          <li class="breadcrumb-item" aria-current="page"><router-link :to="{ name: 'gouvernance' }"><a>Les Gouvernances</a></router-link></li>
          <li class="breadcrumb-item active" aria-current="page"><router-link :to="{ name: 'typeGouvernance' }"><a>Les Types de gouvernance</a></router-link></li>
        </ol>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title fw-bold">Liste des types de gouvernance</h3>
            <div class="card-options">
              <!--                        <SearchInputAll></SearchInputAll>-->
              <button class="btn btn-outline-dark mx-2" @click="showGouvernances"><span class="fe fe-arrow-left-circle"></span> Retour aux gouvernances</button>
            </div>
          </div>
          <div class="card-body">
            <GenericDataTable
                ref="tableRef"
                apiEndpoint="/typeGouvernance/page"
                :columns="columns"
                :filterableFields="filterableFields"
                :rowActions="rowActions"
                :search-field="'nom'"
                @edit="edit"
                @drop="drop"
            >
              <template #cell-createdAt="{ item }">
                {{ item.createdAt | moment('DD-MM-YYYY HH:mm') }}
              </template>
            </GenericDataTable>

          </div>
        </div>
      </div>
      <div class="modal fade" id="modal-composantes" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h6 class="modal-title fw-bold" style="font-size: 16px;">Les composantes du classeur</h6><button aria-label="Close" class="btn-close text-white"
                                                                                                               data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
              <ul class="row p-3">
                <li class="col-lg-12 mb-2">
                  <h4 class="fw-bold">Classeur : {{ classeur?.idTypeGouvernance }} --- {{ classeur?.nomTypeGouvernance }}</h4>
                </li>
                <li class="col-lg-12 mb-2">
                  <div class="table-responsive">
                    <table class="table table-hover table-bordered">
                      <thead>
                      <tr class="text-center info02">
                        <th colspan="10" class="fw-bold">Composantes</th>
                      </tr>
                      <tr class="bg-light">
                        <th class="bg-transparent border-bottom-0 fw-bold">Id Composante</th>
                        <th class="bg-transparent border-bottom-0 fw-bold">Composante</th>
                        <th class="bg-transparent border-bottom-0 fw-bold">
                          Etat</th>
                        <th class="bg-transparent border-bottom-0 fw-bold">
                          Statut</th>
                        <th class="bg-transparent border-bottom-0 fw-bold">
                          Météo</th>
                        <th class="bg-transparent border-bottom-0 fw-bold">
                          Etudes</th>
                        <th class="bg-transparent border-bottom-0 fw-bold">
                          Gouvernance</th>
                        <th class="bg-transparent border-bottom-0 fw-bold">
                          Contrat</th>
                        <th class="bg-transparent border-bottom-0 fw-bold">
                          Exécution</th>
                        <th class="bg-transparent border-bottom-0 fw-bold">
                          Mise en service</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(composante, index) in filtersComposantes" :key="index">
                        <td>{{ composante?.idComposante }}</td>
                        <td>{{ composante?.nomComposante }}</td>
                        <td class="text-center" >
                          <div class="mt-0 mt-sm-3 d-block">
                            <span class="p-2 px-2 alert" :style="'background-color: '  + statusEtat(composante?.etatComposante?.etat)">{{ composante?.etatComposante?.libelle }}</span>
                          </div>
                        </td>
                        <td class="text-center" >
                          <div class="mt-0 mt-sm-3 d-block">
                            <span class="p-2 px-2 alert" :style="'background-color: '  + statusStatut(composante?.statut?.statut)">{{ composante?.statut?.libelle }}</span>
                          </div>
                        </td>
                        <td class="text-center" :style="'background-color: '  + couleurMeteo(composante?.couleur)">
                          <span><small class="fw-bold">{{ composante?.couleur ? composante?.couleur : 'Blanc' }}</small></span>
                        </td>
                        <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(composante?.etudes), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="composante?.etudes ? composante?.etudes : 'Non renseigné'"></span>
                        </td>
                        <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(composante?.gouvernance), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="composante?.gouvernance ? composante?.gouvernance : 'Non renseigné'"></span>
                        </td>
                        <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(composante?.contrat), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="composante?.contrat ? composante?.contrat : 'Non renseigné'"></span>
                        </td>
                        <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(composante?.execution), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="composante?.execution ? composante?.execution : 'Non renseigné'"></span>
                        </td>
                        <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(composante?.miseEnService), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="composante?.miseEnService ? composante?.miseEnService : 'Non renseigné'"></span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <nav class="mt-2">
                    <ul class="pagination justify-content-end">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">&laquo;</a>
                      </li>
                      <li v-for="page in pageCount" :key="page" class="page-item" :class="{ active: currentPage === page }">
                        <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                        <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">&raquo;</a>
                      </li>
                    </ul>
                  </nav>
                </li>
              </ul>
            </div>
            <div class="modal-footer">
              <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
            </div>
          </div>
        </div>
      </div>
      <!-- COL END -->
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4">
        <div class="card overflow-hidden">
          <div class="card-header">
            <h3 class="card-title fw-bold">{{ save ? 'Création d\'un type de gouvernance' : 'Modification d\'un type de gouvernance'}}</h3>
          </div>
          <div class="card-body">
            <ValidationObserver ref="observer" v-slot="{ invalid }">
              <form @submit.prevent="submit" class="">
                <div class="form-row">
                  <div class="form-group col-md-12 mb-0">
                    <ValidationProvider name="Identifiant" rules="" v-slot="{ errors }">
                      <label class="form-label mx-2">ID TYPE DE GOUVERNANCE <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="idTypeGouvernance" v-model="payload.idTypeGouvernance" placeholder="saisir l'identifiant" />
                      <small class="form-text text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12 mb-0">
                    <ValidationProvider name="Libelle" rules="required" v-slot="{ errors }">
                      <label class="form-label">TYPE DE GOUVERNANCE <span class="text-danger">*</span></label>
                      <!-- <input type="text" class="form-control" id="nomTypeGouvernance" v-model="payload.nomTypeGouvernance" placeholder="saisir le nomTypeGouvernance" autocomplete="nomTypeGouvernance"> -->
                      <textarea name="nomTypeGouvernance" v-model="payload.nomTypeGouvernance" class="form-control" id="nomTypeGouvernance" rows="3"></textarea>
                      <small class="form-text text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="form-footer mt-2 d-flex">
                  <div class="col-md-6">
                    <button class="btn btn-success mt-4 mb-0" :disabled="invalid" v-if="save"><span class="fe fe-check"></span> Enregistrer</button>
                    <button class="btn btn-success mt-4 mb-0" :disabled="invalid" v-else><span class="fe fe-check"></span> Modifier</button>
                  </div>
                  <!-- <div class="col-md-6">
                      <router-link :to="{ name: 'composantes' }"><a href="javascript:void(0)" class="btn btn-danger mt-4 mb-0 text-end">Initialiser composante</a></router-link>
                  </div> -->
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-md-8"></div>
      <div class="col-md-4">
        <h5 class="fw-bold mx-5"></h5>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { reduce } from "lodash";
  import $ from 'jquery';
  import { query } from 'vue-gtag';
  import GenericDataTable from "../../../components/GenericDataTable.vue";

  const customLabels = {
    first: '<<',
    last: '>>',
    previous: '<',
    next: '>'
  };

  export default {
    name: "TypeGouvernance",
    components: {GenericDataTable},
    data() {
      return {
        loading: false,
        payload: {idTypeGouvernance: '', nomTypeGouvernance: ''}, save: true, id: '', lesComposantes: [], classeur: {},
        currentPage: 1,
        perPage: 10,
        currentSort: 'idTypeGouvernance',
        currentSortDir: 'asc', customLabels,
        // columns: [
        //     { name: 'idTypeGouvernance', description: 'ID Classeur', type: 'text', used: false },
        //     { name: 'nomTypeGouvernance', description: 'Nom Classeur', type: 'text', used: false },
        // ],
        reinit: false,
        page: { name: 'size', description: '10 par page', value: 10, type: 'number', used: false },
        showFilter: false,
        columns: [
          { key: 'idTypeGouvernance', label: 'ID', class: 'text-center' },
          { key: 'nomTypeGouvernance', label: 'Nom', class: 'classeur-nom' },
        ],
        rowActions : [
          { name: 'edit', event: 'edit', icon: 'fe fe-edit fs-18 text-primary' },
          { name: 'delete', event: 'delete', icon: 'fe fe-trash-2 fs-18 text-danger' },
        ],
        filterableFields :[
          { key: 'id', label: 'ID Type Gouvernance', type: 'text', placeholder: 'Entrer un ID' },
          { key: 'nom', label: 'Nom Type Gouvernance', type: 'text', placeholder: 'Entrer un nom' },
        ]
      }
    },
    computed: {
      ...mapGetters({ items: 'typeGouvernance/list' }),
      sortedItems() {
        return [...this.lesComposantes].sort((a, b) => {
          const aVal = this.resolveSortValue(a);
          const bVal = this.resolveSortValue(b);
          if (this.currentSortDir === 'asc') {
            return aVal > bVal ? 1 : -1;
          } else {
            return aVal < bVal ? 1 : -1;
          }
        });
      },
      filtersComposantes() {
        const start = (this.currentPage - 1) * this.perPage;
        return this.sortedItems.slice(start, start + this.perPage);
      },
      pageCount() {
        return Math.ceil(this.lesComposantes.length / this.perPage);
      },
      // filters() {
      //     return this.columns.filter(o => o.used);
      // },
      // option() {
      //     return reduce(this.filters, (acc, item) => (acc[item.name] = item.value, acc), {})
      // },
    },
    watch: {
      // page: {
      //     deep: true,
      //     immediate: true,
      //     handler(value) {
      //         this.reinit = true;
      //         this.onSearch();
      //     }
      // }
    },
    mounted(){
    },
    methods:{
      ...mapActions('typeGouvernance', ['all', 'add', 'one', 'del', 'allPage']),
      hideModal(){
        $('#modal-composantes').modal('hide');
      },
      sortBy(column) {
        if (this.currentSort === column) {
          this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
        } else {
          this.currentSort = column;
          this.currentSortDir = 'asc';
        }
      },
      changePage(page) {
        if (page >= 1 && page <= this.pageCount) {
          this.currentPage = page;
        }
      },
      resolveSortValue(item) {
        const val = item[this.currentSort];
        if (this.currentSort === 'idComposante') {
          return item.idComposante?.idComposante;
        }else if (this.currentSort === 'nomComposante') {
          return item.idComposante?.nomComposante;
        }
        return typeof val === 'string' ? val.toLowerCase() : val;
      },
      showGouvernances(){
        this.$router.push({ name: 'gouvernance' });
      },
      // onSearch(offset) {
      //     this.$loading(true);
      //     if (offset > 0) this.option.page = offset - 1;
      //     if (this.reinit) {
      //         this.option.page = 0;
      //         this.reinit = false;
      //     }
      //     if (this.page) this.option.size = this.page.value
      //     //this.$router.push({ query: this.option }).catch(() => { });
      //     this.allPage(this.option).finally(() => this.$loading(false));
      // },
      onSearchBack(item) {
        item.used = false;
        // this.onSearch();
      },
      submit() {
        this.$loading(true);
        this.loading = true;

        const confirmationOptions = {
          title: "Confirmation",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: false,
          cancelButtonText: "Annuler",
          confirmButtonColor: "#7db0b2",
          cancelButtonColor: "#FF0000",
          showLoaderOnConfirm: true,
        };

        if (this.save) {
          console.log(this.payload);
          swal({
            ...confirmationOptions,
            text: "Etes-vous sûr de vouloir enregistrer le type de gouvernance ?",
            confirmButtonText: "Enregistrer",
          }, (result) => {
            if (result === true) {
              if(this.payload.idTypeGouvernance === '') return swal('Information !', 'Veuillez renseigner l\'id du type de gouvernance.' + error, 'error');
              this.$loading(true);
              this.$http.post('/typeGouvernance', this.payload)
                  .then(({ data }) => {
                    if (data) {
                      swal('Information!', 'Type de gouvernance enregistré avec succès.', 'success');
                      this.$refs.tableRef.loadData();
                      this.payload = { idTypeGouvernance: '', nomTypeGouvernance: '' };
                      if (this.$refs.observer) {
                        this.$refs.observer.reset();
                      }
                    } else {
                      swal('Information!', 'L\'enregistrement du type de gouvernance n\'a pas pu être effectué.', 'warning');
                    }
                  })
                  .catch((error) => {
                    swal('Information!', 'Une erreur est survenue lors de l\'enregistrement. ' + error, 'warning');
                  })
                  .finally(() => this.$loading(false));
            }
          });
        } else {
          console.log("Editer", this.payload);
          console.log('ID === ', this.id);
          swal({
            ...confirmationOptions,
            text: "Etes-vous sûr de vouloir modifier le type de gouvernance ?",
            confirmButtonText: "Modifier",
          }, (result) => {
            if (result === true) {
              this.$loading(true);
              this.$http.put('/typeGouvernance/' + this.id, this.payload)
                  .then(({ data }) => {
                    if (data) {
                      swal('Information!', 'Type de gouvernance modifié avec succès.', 'success');
                      this.$refs.tableRef.loadData();
                      this.payload = { idTypeGouvernance: '', nomTypeGouvernance: '' };
                      if (this.$refs.observer) {
                        this.$refs.observer.reset();
                      }
                    } else {
                      swal('Information!', 'La modification du type de gouvernance n\'a pas pu être effectuée.', 'warning');
                    }
                  })
                  .catch((error) => {
                    swal('Information!', 'Une erreur est survenue lors de la modification. ' + error, 'warning');
                  })
                  .finally(() => this.$loading(false));
            }
          });
        }
      },
      edit(value){
        this.$loading(true);
        this.save = false;
        this.payload = {...value};
        this.id = this.payload.idTypeGouvernance;
        this.$loading(false);
      },
      drop(item){
        const self = this;
        console.log(item.idTypeGouvernance)
        swal({
          title: "Confirmation",
          text: "Etes-vous sûr de vouloir supprimer le type de gouvernance ?",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: false,
          cancelButtonText: "Annuler",
          confirmButtonText: "Supprimer",
          confirmButtonColor: "#7db0b2",
          cancelButtonColor: "#FF0000",
          showLoaderOnConfirm: true
        }, (result) => {
          if (result === true) {
            self.$loading(true);
            self.$http.delete('/typeGouvernance/' + item.idTypeGouvernance)
                .then(({data}) => {
                  swal('Information!', 'Type de gouvernance supprimé avec succès.', 'success');
                  // self.onSearch();
                  this.$refs.tableRef.loadData();
                })
                .catch((error) => {
                  swal('Information!', 'Une erreur est survenue lors de la suppression. ' + error, 'warning');
                })
                .finally(() => self.$loading(false));
          }
        });
      },
    },
    created() {
      // this.onSearch();
    }
  }
</script>

<style>
th {
  cursor: pointer;
}
.classeur-nom {
  max-width: 220px;
  white-space: normal !important;
  word-wrap: break-word;
  word-break: break-word;
}
</style>